const ComingSoon = ({ description, title }) => {
	return (
		<div className="container-fluid p-4">
			<div className="bg-white rounded shadow-sm p-5">
				<h1
					style={{
						color: "#0f172a",
						fontFamily: "Poppins, sans-serif",
						fontSize: "1.75rem",
						fontWeight: 700,
						marginBottom: 8,
					}}>
					{title}
				</h1>
				<p className="mb-0 text-muted">{description || "This section is coming soon."}</p>
			</div>
		</div>
	);
};

export default ComingSoon;
